import {charcoal} from '../sass/base/_exports.sass';

export const FlagIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 27.2;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M25.6 3.2H4.8V0H1.6v28.8H0V32h6.4v-3.2H4.8v-8h20.8a1.6 1.6 0 0 0 1.6-1.6V4.8a1.6 1.6 0 0 0-1.6-1.6M24 17.6H4.8V6.4H24Z"
      />
    </svg>
  );
};
